export default "__VITE_ASSET__BMczjBin__"